// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import leaveService from '../../services/LeaveService';

// // ─── Async Thunks ──────────────────────────────────────────────────────────

// export const fetchEmployeeLeaveAllocation = createAsyncThunk(
//     'leave/fetchEmployeeLeaveAllocation',
//     async (employeeId, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.GetEmpLeaveAllocation(employeeId);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to fetch leave allocation.");
//             }

//             return response?.ResultSet || [];
//         } catch (error) {
//             console.error("[fetchEmployeeLeaveAllocation] Error:", error);
//             return rejectWithValue(error.message || "Failed to load leave allocation.");
//         }
//     }
// );

// export const fetchLeaveRequestsByStatus = createAsyncThunk(
//     'leave/fetchLeaveRequestsByStatus',
//     async (status, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.GetLeavesRequestByStatus(status);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to fetch leave requests.");
//             }

//             return response?.ResultSet || [];
//         } catch (error) {
//             console.error("[fetchLeaveRequestsByStatus] Error:", error);
//             return rejectWithValue(error.message || "Failed to load leave requests.");
//         }
//     }
// );

// export const fetchLeaveDetailsByUser = createAsyncThunk(
//     'leave/fetchLeaveDetailsByUser',
//     async (employeeId, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.GetLeaveDetailsByUser(employeeId);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to fetch leave details.");
//             }

//             return response?.ResultSet || [];
//         } catch (error) {
//             console.error("[fetchLeaveDetailsByUser] Error:", error);
//             return rejectWithValue(error.message || "Failed to load leave details.");
//         }
//     }
// );

// export const submitLeaveRequest = createAsyncThunk(
//     'leave/submitLeaveRequest',
//     async (leaveData, { rejectWithValue }) => {
//         try {
//             const {
//                 EmpServiceNo,
//                 FormNo,
//                 LeaveType,
//                 FromDate,
//                 ToDate,
//                 IsHalfDay,
//                 HalfDayType,
//                 Reason,
//                 ContactNo,
//                 AttachmentPath,
//                 UserId
//             } = leaveData;

//             const response = await leaveService.RequestLeave(
//                 EmpServiceNo,
//                 FormNo,
//                 LeaveType,
//                 FromDate,
//                 ToDate,
//                 IsHalfDay,
//                 HalfDayType,
//                 Reason,
//                 ContactNo,
//                 AttachmentPath,
//                 UserId
//             );

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to submit leave request.");
//             }

//             return response;
//         } catch (error) {
//             console.error("[submitLeaveRequest] Error:", error);
//             return rejectWithValue(error.message || "Failed to submit leave request.");
//         }
//     }
// );

// export const approveLeave = createAsyncThunk(
//     'leave/approveLeave',
//     async ({ LeaveFormId, FormNo, UserId, Reason }, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.AcceptLeave(LeaveFormId, FormNo, UserId, Reason);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to approve leave.");
//             }

//             return response;
//         } catch (error) {
//             console.error("[approveLeave] Error:", error);
//             return rejectWithValue(error.message || "Failed to approve leave.");
//         }
//     }
// );

// export const rejectLeave = createAsyncThunk(
//     'leave/rejectLeave',
//     async ({ LeaveFormId, FormNo, UserId, Reason }, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.RejectLeave(LeaveFormId, FormNo, UserId, Reason);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to reject leave.");
//             }

//             return response;
//         } catch (error) {
//             console.error("[rejectLeave] Error:", error);
//             return rejectWithValue(error.message || "Failed to reject leave.");
//         }
//     }
// );

// export const cancelLeave = createAsyncThunk(
//     'leave/cancelLeave',
//     async ({ LeaveFormId, FormNo, UserId }, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.CancelLeave(LeaveFormId, FormNo, UserId);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to cancel leave.");
//             }

//             return response;
//         } catch (error) {
//             console.error("[cancelLeave] Error:", error);
//             return rejectWithValue(error.message || "Failed to cancel leave.");
//         }
//     }
// );

// // ─── Check for duplicate leave request ────────────────────────────────────
// export const checkDuplicateLeave = createAsyncThunk(
//     'leave/checkDuplicate',
//     async ({ serviceNo, formNo, startDate, endDate, leaveType }, { rejectWithValue }) => {
//         try {
//             const response = await leaveService.GetLeaveDetailsByUser(serviceNo);

//             if (response?.StatusCode !== 200) {
//                 throw new Error(response?.Message || "Failed to check duplicate leave.");
//             }

//             const existingLeaves = response?.ResultSet || [];

//             // Check for duplicate Form No
//             const duplicateFormNo = existingLeaves.find(
//                 leave => leave.HLF_FORM_NO === formNo
//             );

//             if (duplicateFormNo) {
//                 return {
//                     isDuplicate: true,
//                     message: `Leave Form No "${formNo}" already exists. Please use a unique Form No.`
//                 };
//             }

//             // Check for duplicate date range for the same leave type
//             const normalizedStartDate = startDate.replace(/-/g, '');
//             const normalizedEndDate = endDate.replace(/-/g, '');

//             const duplicateDateRange = existingLeaves.some(leave => {
//                 const leaveStart = leave.HLF_FROM_DATE?.replace(/-/g, '') || '';
//                 const leaveEnd = leave.HLF_TO_DATE?.replace(/-/g, '') || '';
//                 const leaveTypeId = leave.HLF_LEAVE_TYPE_ID || '';

//                 // Only check if same leave type
//                 if (leaveTypeId === leaveType) {
//                     const newStart = parseInt(normalizedStartDate);
//                     const newEnd = parseInt(normalizedEndDate);
//                     const existingStart = parseInt(leaveStart);
//                     const existingEnd = parseInt(leaveEnd);

//                     // Check for date overlap
//                     if (newStart <= existingEnd && newEnd >= existingStart) {
//                         return true;
//                     }
//                 }
//                 return false;
//             });

//             if (duplicateDateRange) {
//                 return {
//                     isDuplicate: true,
//                     message: `You already have a leave request for this date range. Please check your existing requests.`
//                 };
//             }

//             return { isDuplicate: false };
//         } catch (error) {
//             console.error("[checkDuplicateLeave] Error:", error);
//             return rejectWithValue(error.message || "Failed to check duplicate leave.");
//         }
//     }
// );

// // ─── Slice ──────────────────────────────────────────────────────────────────

// const initialState = {
//     leaveAllocation: [],
//     leaveRequests: [],
//     leaveDetails: [],
//     duplicateCheck: null,
//     loading: false,
//     submitting: false,
//     checkingDuplicate: false,
//     error: null,
//     success: false,
// };

// const leaveSlice = createSlice({
//     name: 'leave',
//     initialState,
//     reducers: {
//         clearLeaveError: (state) => {
//             state.error = null;
//         },
//         clearLeaveSuccess: (state) => {
//             state.success = false;
//         },
//         resetLeaveState: (state) => {
//             state.leaveAllocation = [];
//             state.leaveRequests = [];
//             state.leaveDetails = [];
//             state.duplicateCheck = null;
//             state.loading = false;
//             state.submitting = false;
//             state.checkingDuplicate = false;
//             state.error = null;
//             state.success = false;
//         },
//         clearDuplicateCheck: (state) => {
//             state.duplicateCheck = null;
//         },
//     },
//     extraReducers: (builder) => {
//         builder
//             // ─── Fetch Leave Allocation ──────────────────────────────────────
//             .addCase(fetchEmployeeLeaveAllocation.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(fetchEmployeeLeaveAllocation.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.leaveAllocation = action.payload || [];
//                 state.error = null;
//             })
//             .addCase(fetchEmployeeLeaveAllocation.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Failed to fetch leave allocation.";
//                 state.leaveAllocation = [];
//             })

//             // ─── Fetch Leave Requests by Status ─────────────────────────────
//             .addCase(fetchLeaveRequestsByStatus.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(fetchLeaveRequestsByStatus.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.leaveRequests = action.payload || [];
//                 state.error = null;
//             })
//             .addCase(fetchLeaveRequestsByStatus.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Failed to fetch leave requests.";
//                 state.leaveRequests = [];
//             })

//             // ─── Fetch Leave Details by User ────────────────────────────────
//             .addCase(fetchLeaveDetailsByUser.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(fetchLeaveDetailsByUser.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.leaveDetails = action.payload || [];
//                 state.error = null;
//             })
//             .addCase(fetchLeaveDetailsByUser.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload || "Failed to fetch leave details.";
//                 state.leaveDetails = [];
//             })

//             // ─── Check Duplicate Leave ──────────────────────────────────────
//             .addCase(checkDuplicateLeave.pending, (state) => {
//                 state.checkingDuplicate = true;
//                 state.error = null;
//                 state.duplicateCheck = null;
//             })
//             .addCase(checkDuplicateLeave.fulfilled, (state, action) => {
//                 state.checkingDuplicate = false;
//                 state.duplicateCheck = action.payload;
//                 state.error = null;
//             })
//             .addCase(checkDuplicateLeave.rejected, (state, action) => {
//                 state.checkingDuplicate = false;
//                 state.error = action.payload || "Failed to check duplicate leave.";
//             })

//             // ─── Submit Leave Request ────────────────────────────────────────
//             .addCase(submitLeaveRequest.pending, (state) => {
//                 state.submitting = true;
//                 state.error = null;
//                 state.success = false;
//             })
//             .addCase(submitLeaveRequest.fulfilled, (state) => {
//                 state.submitting = false;
//                 state.success = true;
//                 state.error = null;
//             })
//             .addCase(submitLeaveRequest.rejected, (state, action) => {
//                 state.submitting = false;
//                 state.error = action.payload || "Failed to submit leave request.";
//                 state.success = false;
//             })

//             // ─── Approve Leave ───────────────────────────────────────────────
//             .addCase(approveLeave.pending, (state) => {
//                 state.submitting = true;
//                 state.error = null;
//             })
//             .addCase(approveLeave.fulfilled, (state) => {
//                 state.submitting = false;
//                 state.success = true;
//                 state.error = null;
//             })
//             .addCase(approveLeave.rejected, (state, action) => {
//                 state.submitting = false;
//                 state.error = action.payload || "Failed to approve leave.";
//             })

//             // ─── Reject Leave ────────────────────────────────────────────────
//             .addCase(rejectLeave.pending, (state) => {
//                 state.submitting = true;
//                 state.error = null;
//             })
//             .addCase(rejectLeave.fulfilled, (state) => {
//                 state.submitting = false;
//                 state.success = true;
//                 state.error = null;
//             })
//             .addCase(rejectLeave.rejected, (state, action) => {
//                 state.submitting = false;
//                 state.error = action.payload || "Failed to reject leave.";
//             })

//             // ─── Cancel Leave ────────────────────────────────────────────────
//             .addCase(cancelLeave.pending, (state) => {
//                 state.submitting = true;
//                 state.error = null;
//             })
//             .addCase(cancelLeave.fulfilled, (state) => {
//                 state.submitting = false;
//                 state.success = true;
//                 state.error = null;
//             })
//             .addCase(cancelLeave.rejected, (state, action) => {
//                 state.submitting = false;
//                 state.error = action.payload || "Failed to cancel leave.";
//             });
//     },
// });

// export const {
//     clearLeaveError,
//     clearLeaveSuccess,
//     resetLeaveState,
//     clearDuplicateCheck,
// } = leaveSlice.actions;

// export default leaveSlice.reducer;

// // ─── Selectors ─────────────────────────────────────────────────────────────

// export const selectLeaveAllocation = (state) => state.leave.leaveAllocation;
// export const selectLeaveRequests = (state) => state.leave.leaveRequests;
// export const selectLeaveDetails = (state) => state.leave.leaveDetails;
// export const selectLeaveDuplicateCheck = (state) => state.leave.duplicateCheck;
// export const selectLeaveLoading = (state) => state.leave.loading;
// export const selectLeaveSubmitting = (state) => state.leave.submitting;
// export const selectLeaveCheckingDuplicate = (state) => state.leave.checkingDuplicate;
// export const selectLeaveError = (state) => state.leave.error;
// export const selectLeaveSuccess = (state) => state.leave.success;



import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import leaveService from '../../services/LeaveService';


const isOk = (response) => {
  const code = Number(response?.StatusCode);
  return code === 200 || code === 201;
};

const rowsOf = (response) => response?.ResultSet || response?.resultSet || [];

const messageOf = (response, fallback) =>
  response?.Message || response?.message || response?.Result || fallback;

const num = (v) => Number(v) || 0;


const resolveActingUserId = (passedUserId) => {
  try {
    const stored = localStorage.getItem('ADU_EmployeeId');
    if (stored) {
      const data = JSON.parse(stored);
      const id = data?.ADU_EmployeeId || data?.raw?.ADU_EmployeeId || data?.serviceNo;
      if (id) return id;
    }
  } catch {
  }
  return passedUserId;
};

/**
 * Normalise the type-wise API rows into a grouped-by-employee shape
 */
const groupLeaveSummary = (rows) => {
  const map = new Map();
  const typeRegistry = new Map(); // code -> { code, name, typeId }

  rows.forEach((r) => {
    const serviceNo = r.HLA_EMP_SERVICE_NO || '';
    const code = r.LEAVE_TYPE_CODE || 'UNK';
    const typeId = r.HLA_LEAVE_TYPE_ID || '';
    const typeName = r.LEAVE_TYPE_NAME || code;

    if (!typeRegistry.has(code)) {
      typeRegistry.set(code, { code, name: typeName, typeId });
    }

    if (!map.has(serviceNo)) {
      map.set(serviceNo, {
        serviceNo,
        employeeName: r.EMPLOYEE_NAME || '',
        leaveYear: r.HLA_LEAVE_YEAR || '',
        totalAllocated: 0,
        totalEarned: 0,
        totalAdjustment: 0,
        totalUsed: 0,
        totalBalance: 0,
        types: {},
      });
    }

    const emp = map.get(serviceNo);
    const allocated = num(r.TOTAL_ALLOCATED_DAYS);
    const earned = num(r.TOTAL_EARNED_DAYS);
    const adjustment = num(r.TOTAL_ADJUSTMENT_DAYS);
    const used = num(r.TOTAL_USED_DAYS);
    const balance = num(r.TOTAL_BALANCE_DAYS);

    emp.types[code] = {
      typeId,
      code,
      name: typeName,
      allocated,
      earned,
      adjustment,
      used,
      balance,
    };

    emp.totalAllocated += allocated;
    emp.totalEarned += earned;
    emp.totalAdjustment += adjustment;
    emp.totalUsed += used;
    emp.totalBalance += balance;
  });

  const typeList = Array.from(typeRegistry.values()).sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const employees = Array.from(map.values()).sort((a, b) =>
    a.employeeName.localeCompare(b.employeeName)
  );

  return { employees, typeList };
};

// ─── Async Thunks ──────────────────────────────────────────────────────────

export const fetchEmployeeLeaveAllocation = createAsyncThunk(
  'leave/fetchEmployeeLeaveAllocation',
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await leaveService.GetEmpLeaveAllocation(employeeId);

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to fetch leave allocation.'));
      }

      return rowsOf(response);
    } catch (error) {
      console.error('[fetchEmployeeLeaveAllocation] Error:', error);
      return rejectWithValue(error.message || 'Failed to load leave allocation.');
    }
  }
);

export const fetchLeaveRequestsByStatus = createAsyncThunk(
  'leave/fetchLeaveRequestsByStatus',
  async (status, { rejectWithValue }) => {
    try {
      const response = await leaveService.GetLeavesRequestByStatus(status);

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to fetch leave requests.'));
      }

      return rowsOf(response);
    } catch (error) {
      console.error('[fetchLeaveRequestsByStatus] Error:', error);
      return rejectWithValue(error.message || 'Failed to load leave requests.');
    }
  }
);

export const fetchLeaveDetailsByUser = createAsyncThunk(
  'leave/fetchLeaveDetailsByUser',
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await leaveService.GetLeaveDetailsByUser(employeeId);

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to fetch leave details.'));
      }

      return rowsOf(response);
    } catch (error) {
      console.error('[fetchLeaveDetailsByUser] Error:', error);
      return rejectWithValue(error.message || 'Failed to load leave details.');
    }
  }
);

/**
 * Type-wise leave summary
 */
export const fetchEmployeeLeaveSummary = createAsyncThunk(
  'leave/fetchEmployeeLeaveSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await leaveService.GetEmpLeaveSummary();

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to fetch leave summary.'));
      }

      const rows = rowsOf(response);
      return groupLeaveSummary(rows); // { employees, typeList }
    } catch (error) {
      console.error('[fetchEmployeeLeaveSummary] Error:', error);
      return rejectWithValue(error.message || 'Failed to load leave summary.');
    }
  }
);

export const submitLeaveRequest = createAsyncThunk(
  'leave/submitLeaveRequest',
  async (leaveData, { rejectWithValue }) => {
    try {
      const {
        EmpServiceNo,
        FormNo,
        LeaveType,
        FromDate,
        ToDate,
        IsHalfDay,
        HalfDayType,
        Reason,
        ContactNo,
        AttachmentPath,
        UserId,
      } = leaveData;

      const response = await leaveService.RequestLeave(
        EmpServiceNo,
        FormNo,
        LeaveType,
        FromDate,
        ToDate,
        IsHalfDay,
        HalfDayType,
        Reason,
        ContactNo,
        AttachmentPath,
        UserId
      );

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to submit leave request.'));
      }

      return response;
    } catch (error) {
      console.error('[submitLeaveRequest] Error:', error);
      return rejectWithValue(error.message || 'Failed to submit leave request.');
    }
  }
);

export const approveLeave = createAsyncThunk(
  'leave/approveLeave',
  async ({ LeaveFormId, FormNo, UserId, Reason }, { rejectWithValue }) => {
    try {
      const response = await leaveService.AcceptLeave(
        LeaveFormId,
        FormNo,
        resolveActingUserId(UserId),
        Reason
      );

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to approve leave.'));
      }

      return response;
    } catch (error) {
      console.error('[approveLeave] Error:', error);
      return rejectWithValue(error.message || 'Failed to approve leave.');
    }
  }
);

export const rejectLeave = createAsyncThunk(
  'leave/rejectLeave',
  async ({ LeaveFormId, FormNo, UserId, Reason }, { rejectWithValue }) => {
    try {
      const response = await leaveService.RejectLeave(
        LeaveFormId,
        FormNo,
        resolveActingUserId(UserId),
        Reason
      );

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to reject leave.'));
      }

      return response;
    } catch (error) {
      console.error('[rejectLeave] Error:', error);
      return rejectWithValue(error.message || 'Failed to reject leave.');
    }
  }
);

export const cancelLeave = createAsyncThunk(
  'leave/cancelLeave',
  async ({ LeaveFormId, FormNo, UserId }, { rejectWithValue }) => {
    try {
      const response = await leaveService.CancelLeave(
        LeaveFormId,
        FormNo,
        resolveActingUserId(UserId)
      );

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to cancel leave.'));
      }

      return response;
    } catch (error) {
      console.error('[cancelLeave] Error:', error);
      return rejectWithValue(error.message || 'Failed to cancel leave.');
    }
  }
);

// ─── Check for duplicate leave request ────────────────────────────────────
export const checkDuplicateLeave = createAsyncThunk(
  'leave/checkDuplicate',
  async (
    { serviceNo, formNo, startDate, endDate, leaveType },
    { rejectWithValue }
  ) => {
    try {
      const response = await leaveService.GetLeaveDetailsByUser(serviceNo);

      if (!isOk(response)) {
        throw new Error(messageOf(response, 'Failed to check duplicate leave.'));
      }

      const existingLeaves = rowsOf(response);

      // Check for duplicate Form No
      const duplicateFormNo = existingLeaves.find(
        (leave) => leave.HLF_FORM_NO === formNo
      );

      if (duplicateFormNo) {
        return {
          isDuplicate: true,
          message: `Leave Form No "${formNo}" already exists. Please use a unique Form No.`,
        };
      }

      // Check for duplicate date range for the same leave type
      const normalizedStartDate = startDate.replace(/-/g, '');
      const normalizedEndDate = endDate.replace(/-/g, '');

      const duplicateDateRange = existingLeaves.some((leave) => {
        const leaveStart = leave.HLF_FROM_DATE?.replace(/-/g, '') || '';
        const leaveEnd = leave.HLF_TO_DATE?.replace(/-/g, '') || '';
        const leaveTypeId = leave.HLF_LEAVE_TYPE_ID || '';

        // Only check if same leave type
        if (leaveTypeId === leaveType) {
          const newStart = parseInt(normalizedStartDate);
          const newEnd = parseInt(normalizedEndDate);
          const existingStart = parseInt(leaveStart);
          const existingEnd = parseInt(leaveEnd);

          // Check for date overlap
          if (newStart <= existingEnd && newEnd >= existingStart) {
            return true;
          }
        }
        return false;
      });

      if (duplicateDateRange) {
        return {
          isDuplicate: true,
          message: `You already have a leave request for this date range. Please check your existing requests.`,
        };
      }

      return { isDuplicate: false };
    } catch (error) {
      console.error('[checkDuplicateLeave] Error:', error);
      return rejectWithValue(error.message || 'Failed to check duplicate leave.');
    }
  }
);

// ─── Slice ──────────────────────────────────────────────────────────────────

const initialState = {
  leaveAllocation: [],
  leaveRequests: [],
  leaveDetails: [],
  leaveSummary: [],       // grouped-by-employee rows
  leaveTypeList: [],      // stable list of { code, name, typeId }
  duplicateCheck: null,
  loading: false,
  summaryLoading: false,
  submitting: false,
  checkingDuplicate: false,
  error: null,
  success: false,
};

const leaveSlice = createSlice({
  name: 'leave',
  initialState,
  reducers: {
    clearLeaveError: (state) => {
      state.error = null;
    },
    clearLeaveSuccess: (state) => {
      state.success = false;
    },
    resetLeaveState: (state) => {
      state.leaveAllocation = [];
      state.leaveRequests = [];
      state.leaveDetails = [];
      state.leaveSummary = [];
      state.leaveTypeList = [];
      state.duplicateCheck = null;
      state.loading = false;
      state.summaryLoading = false;
      state.submitting = false;
      state.checkingDuplicate = false;
      state.error = null;
      state.success = false;
    },
    clearDuplicateCheck: (state) => {
      state.duplicateCheck = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ─── Fetch Leave Allocation ──────────────────────────────────────
      .addCase(fetchEmployeeLeaveAllocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeLeaveAllocation.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveAllocation = action.payload || [];
        state.error = null;
      })
      .addCase(fetchEmployeeLeaveAllocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch leave allocation.';
        state.leaveAllocation = [];
      })

      // ─── Fetch Employee Leave Summary (type-wise) ───────────────────
      .addCase(fetchEmployeeLeaveSummary.pending, (state) => {
        state.summaryLoading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeLeaveSummary.fulfilled, (state, action) => {
        state.summaryLoading = false;
        state.leaveSummary = action.payload?.employees || [];
        state.leaveTypeList = action.payload?.typeList || [];
        state.error = null;
      })
      .addCase(fetchEmployeeLeaveSummary.rejected, (state, action) => {
        state.summaryLoading = false;
        state.error = action.payload || 'Failed to fetch leave summary.';
        state.leaveSummary = [];
        state.leaveTypeList = [];
      })

      // ─── Fetch Leave Requests by Status ─────────────────────────────
      .addCase(fetchLeaveRequestsByStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaveRequestsByStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveRequests = action.payload || [];
        state.error = null;
      })
      .addCase(fetchLeaveRequestsByStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch leave requests.';
        state.leaveRequests = [];
      })

      // ─── Fetch Leave Details by User ────────────────────────────────
      .addCase(fetchLeaveDetailsByUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaveDetailsByUser.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveDetails = action.payload || [];
        state.error = null;
      })
      .addCase(fetchLeaveDetailsByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch leave details.';
        state.leaveDetails = [];
      })

      // ─── Check Duplicate Leave ──────────────────────────────────────
      .addCase(checkDuplicateLeave.pending, (state) => {
        state.checkingDuplicate = true;
        state.error = null;
        state.duplicateCheck = null;
      })
      .addCase(checkDuplicateLeave.fulfilled, (state, action) => {
        state.checkingDuplicate = false;
        state.duplicateCheck = action.payload;
        state.error = null;
      })
      .addCase(checkDuplicateLeave.rejected, (state, action) => {
        state.checkingDuplicate = false;
        state.error = action.payload || 'Failed to check duplicate leave.';
      })

      // ─── Submit Leave Request ────────────────────────────────────────
      .addCase(submitLeaveRequest.pending, (state) => {
        state.submitting = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitLeaveRequest.fulfilled, (state) => {
        state.submitting = false;
        state.success = true;
        state.error = null;
      })
      .addCase(submitLeaveRequest.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload || 'Failed to submit leave request.';
        state.success = false;
      })

      // ─── Approve Leave ───────────────────────────────────────────────
      .addCase(approveLeave.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(approveLeave.fulfilled, (state) => {
        state.submitting = false;
        state.success = true;
        state.error = null;
      })
      .addCase(approveLeave.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload || 'Failed to approve leave.';
      })

      // ─── Reject Leave ────────────────────────────────────────────────
      .addCase(rejectLeave.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(rejectLeave.fulfilled, (state) => {
        state.submitting = false;
        state.success = true;
        state.error = null;
      })
      .addCase(rejectLeave.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload || 'Failed to reject leave.';
      })

      // ─── Cancel Leave ────────────────────────────────────────────────
      .addCase(cancelLeave.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(cancelLeave.fulfilled, (state) => {
        state.submitting = false;
        state.success = true;
        state.error = null;
      })
      .addCase(cancelLeave.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload || 'Failed to cancel leave.';
      });
  },
});

export const {
  clearLeaveError,
  clearLeaveSuccess,
  resetLeaveState,
  clearDuplicateCheck,
} = leaveSlice.actions;

export default leaveSlice.reducer;

// ─── Selectors ─────────────────────────────────────────────────────────────

export const selectLeaveAllocation = (state) => state.leave.leaveAllocation;
export const selectLeaveRequests = (state) => state.leave.leaveRequests;
export const selectLeaveDetails = (state) => state.leave.leaveDetails;
export const selectLeaveSummary = (state) => state.leave.leaveSummary;
export const selectLeaveTypeList = (state) => state.leave.leaveTypeList;
export const selectLeaveSummaryLoading = (state) => state.leave.summaryLoading;
export const selectLeaveDuplicateCheck = (state) => state.leave.duplicateCheck;
export const selectLeaveLoading = (state) => state.leave.loading;
export const selectLeaveSubmitting = (state) => state.leave.submitting;
export const selectLeaveCheckingDuplicate = (state) => state.leave.checkingDuplicate;
export const selectLeaveError = (state) => state.leave.error;
export const selectLeaveSuccess = (state) => state.leave.success;